/**
 * MESSAGE TOKENS
 *
 * Custom additions are marked with "Custom" comments below.
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createMessageTokens(s: SemanticTokens) {
  return {
    /** Base spacing and typography for messages */
    base: {
      paddingX: v('messages.base.padding-x'), // --messages-base-padding-x: var(--spacing-16)
      paddingY: v('messages.base.padding-y'), // --messages-base-padding-y: var(--spacing-16)
      gap: v('messages.base.gap'), // --messages-base-gap: var(--spacing-8)
      radius: v('messages.base.radius'), // --messages-base-radius: var(--radius-8)

      // ── Custom base additions ──
      textGap: s.layout.gap.xs, // --messages-base-text-gap: var(--spacing-4) — gap between title and body
      width: '20rem', // --messages-base-width: 320px
      transitionDuration: '0.3s', // --messages-base-transition-duration
      blur: '0', // --messages-base-blur: no backdrop blur
      titleFontSize: s.typography.fontSize.lg, // --text-size-lg: 1.125rem (18px)
      titleFontWeight: s.typography.fontWeight.semibold, // --font-weight-semibold: 600
      bodyFontSize: s.typography.fontSize.base, // --text-size-base: 1rem (16px)
      bodyFontWeight: s.typography.fontWeight.normal, // --font-weight-normal: 400
      closeButtonSize: s.layout.gap.xl, // --messages-close-button-size: 2rem (32px)
      closeButtonRadius: '50%', // --messages-close-button-radius: circular
      closeIconSize: s.typography.fontSize.base, // --messages-close-icon-size: 1rem (16px)
      shadow: v('shadow.message'), // --messages-base-shadow
      fontFamily: s.typography.fontFamily.base, // --messages-base-font-family
      borderWidth: '1px', // --messages-base-border-width
      iconSize: s.iconSizes.lg, // --messages-base-icon-size
      toastIconSize: s.iconSizes.md, // --messages-base-toast-icon-size
      toastBorderWidth: '0 0 0 4px', // --messages-base-toast-border-width
      summaryFontWeight: s.typography.fontWeight.semibold, // --messages-base-summary-font-weight
      summaryLineHeight: s.typography.lineHeight['2xl'], // --messages-base-summary-line-height
      iconMarginTop: '0.25rem', // --messages-base-icon-margin-top
    },
    success: {
      bg: v('messages.success.bg'), // --messages-success-bg: var(--states-success-bg)
      fg: v('messages.success.fg'), // --messages-success-fg: var(--states-success-fg)
      border: v('messages.success.border'), // --messages-success-border: var(--states-success-border)
    },
    danger: {
      bg: v('messages.danger.bg'), // --messages-error-bg: var(--states-danger-bg)
      fg: v('messages.danger.fg'), // --messages-error-fg: var(--states-danger-fg)
      border: v('messages.danger.border'), // --messages-error-border: var(--states-danger-border)
    },
    warning: {
      bg: v('messages.warning.bg'), // --messages-warning-bg: var(--states-warning-bg)
      fg: v('messages.warning.fg'), // --messages-warning-fg: var(--states-warning-fg)
      border: v('messages.warning.border'), // --messages-warning-border: var(--states-warning-border)
    },
    info: {
      bg: v('messages.info.bg'), // --messages-neutral-info-bg: var(--color-neutral-white)
      fg: v('messages.info.fg'), // --messages-neutral-info-fg: var(--color-rentsody-800)
      border: v('messages.info.border'), // --messages-neutral-info-border: var(--color-rentsody-800)
    },

    // ──── Custom tokens ────

    secondary: {
      bg: s.surface.ground, // --messages-secondary-bg: var(--surface-ground)
      fg: s.text.secondary, // --messages-secondary-fg: var(--text-secondary)
      border: s.border.secondary, // --messages-secondary-border: var(--border-secondary)
    },
  };
}
export const messageTokens = createMessageTokens(SEMANTIC);
